import React from 'react'
import { useToast } from '../../hooks/useToast.jsx'

// The one copy control: an inline lucide `copy` icon that writes `value` to the
// clipboard and confirms in a toast. The toast renders through the single
// <ToastContainer /> that Layout mounts.

const COPY_FAILED_MESSAGE = "Couldn't copy. Copy it by hand."

const ICON_PROPS = {
  viewBox: '0 0 24 24',
  width: 14,
  height: 14,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
}

/**
 * @param {{ value: string, label: string, toastMessage?: string, className?: string }} props
 *   label is the accessible name, since the button shows only an icon.
 */
export default function CopyButton({ value, label, toastMessage = 'Copied', className = '' }) {
  const { toast } = useToast()

  async function handleClick(event) {
    event.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      toast.success(toastMessage)
    } catch (error) {
      console.error('Clipboard write failed:', error)
      toast.error(COPY_FAILED_MESSAGE)
    }
  }

  return (
    <button
      type="button"
      className={`btn btn-ghost btn-xs copy-button ${className}`.trim()}
      onClick={handleClick}
      aria-label={label}
      title={label}
      style={{ padding: 2, lineHeight: 0, verticalAlign: 'middle' }}
    >
      <CopyIcon />
    </button>
  )
}

function CopyIcon() {
  return (
    <svg {...ICON_PROPS}>
      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </svg>
  )
}
